module.exports = __webpack_public_path__ + "static/img/20230428_02.1c597b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230428_02.png
// module id = 4s3Y
// module chunks = 0